const customStyles = {
  control: (provided) => ({
    ...provided,
    border: 'none',
    borderLeft: '2px solid #d1d1d2',
    borderRadius: '0',
    boxShadow: 'none',
    cursor: 'pointer',
    '&:hover': {
      borderColor: '#d1d1d2',
    },
  }),

  container: (provided) => ({
    ...provided,
    width: '200px',
  }),

  indicatorSeparator: (provided) => ({
    ...provided,
    backgroundColor: 'transparent',
  }),

  input: (provided) => ({
    ...provided,
    color: '#707070',
    fontFamily: 'Source Sans Pro',
    fontSize: '18px',
  }),

  menu: (provided) => ({
    ...provided,
    backgroundColor: '#fff',
  }),

  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? '#eeb193' : state.isSelected ? 'var(--secondary-color)' : 'transparent',
    cursor: 'pointer',
  }),
};

export default customStyles;
